import type {
  MessageMetadata,
  MessageMetadataParams,
} from '../types/lib/message-helpers.types';

/**
 * Computes metadata for a message to determine rendering behavior.
 * Composable helper for message display logic.
 */
export function getMessageMetadata({
  message,
  index,
  lastAgentMessageIndex,
  showLogoOnLastAgentMessage,
  isStreaming,
  activeAgentMessageId,
}: MessageMetadataParams): MessageMetadata {
  const isLastAgentMessage =
    !message.isUser &&
    index === lastAgentMessageIndex &&
    showLogoOnLastAgentMessage;

  const isActiveStreamingMessage =
    !message.isUser &&
    isStreaming &&
    activeAgentMessageId === message.id &&
    index === lastAgentMessageIndex;

  // Business rule: Streaming messages render inline and update in-place as text streams in.
  // The message text is updated by the reducer via upsertMessage, so no skip needed.
  const shouldSkipRender = false;

  return {
    isLastAgentMessage,
    isActiveStreamingMessage,
    shouldSkipRender,
  };
}
